import React, { useEffect, useState } from 'react';
import './App.css';
import { ReactComponent as Logo } from '../assets/logo.svg';
import vitamin from '../assets/vitamin.jpg';
import AppBar from '@mui/material/AppBar';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import DensitySmallIcon from '@mui/icons-material/DensitySmall'
import { getProduct, postOrder } from './api/konnective';
import FilledInput from '../components/FilledInput'; 
import Dropdown from '../components/Dropdown';
import BillingCheckbox from '../components/BillingCheckbox';
import { useUrlQuery } from '../lib/get-url-params';
import { Order } from '../types/api';
import Skeleton from '@mui/material/Skeleton';

const styles = {
  customizeToolbar: {
    minHeight: 75,
    backgroundColor: 'white',
    boxShadow: 'none',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'left'
  }
};



const isValidName = (value: string) => value.length >= 2 ? "" : 'Name must be at least 2 characters';
const isValidEmail = (value: string) => /\S+@\S+\.\S+/.test(value) ? "" : 'Invalid email address';
const isValidCity = (value: string) => value.trim().length > 0 ? "" : 'City cannot be empty';
const isValidPhone = (value: string) => /^\d{10}$/.test(value) ? "" : 'Phone number must be 10 digits';
const isValidZip = (value: string) => /^\d{5}(-\d{4})?$/.test(value) ? "" : 'Invalid zip/postal code';
const isValidCreditCard = (value: string) => /^\d{16}$/.test(value.replace(/\s/g, '')) ? "" : 'Invalid credit card number';
const isValidExpirationDate = (value: string) => /^(0[1-9]|1[0-2])\/\d{2}$/.test(value) ? "" : 'Invalid expiration date (MM/YY)';
const isValidCVV = (value: string) => /^\d{3,4}$/.test(value) ? "" : 'Invalid CVV';
const isValidAddress = (value: string) => value.trim().length >= 5 ? "" : 'Address must be at least 5 characters';


function App() {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  const [isThankYouPage, setIsThankYouPage] = React.useState(false);
  const [product, setProduct] = useState();
  const [order, setOrder] = useState<any>({});

  const productId = useUrlQuery().get('productId');

  useEffect(() => {
    (async () => {
      if (productId) {
        let productResponse =  await getProduct(productId);
        console.log(productResponse);
        try {
          setProduct(productResponse?.message.data[0]); 
        } catch (e) {}
      } else {
          console.warn('Product ID is null or undefined');
      }
    })();
  }, []);

  return (
    <div className="App">
      <AppBar position="static" sx={styles.customizeToolbar}>
        <Logo width='75' height='75'/>
      </AppBar>
      {
        isThankYouPage ? <ThankYouPage orderId={order?.orderId}/> : isMobileOrTablet ?
          MobileCheckout({setIsThankYouPage, product, order, setOrder}) : 
          DesktopCheckout({setIsThankYouPage, product, order, setOrder})
      }
    </div>
  );
}

function MobileCheckout({setIsThankYouPage, product, order, setOrder}: any) {
  return (
    <>
      <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5'  }}>
        <Accordion sx={{ boxShadow: 'none', background: '#f5f5f5'}}>
          <AccordionSummary expandIcon={<DensitySmallIcon />}> 
            <div className='summary-header'>Order Summary</div>
          </AccordionSummary>
          <AccordionDetails sx={{ borderBottom: '1px solid #e0e0e0' }}>
            <OrderSummary product={product}/>
          </AccordionDetails>
        </Accordion>
      </AppBar>
      <Box className="container" sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', placeSelf: 'end'}}>
        <StoreForm setIsThankYouPage={setIsThankYouPage} product={product} order={order} setOrder={setOrder}/>
      </Box>
    </>
  );
}

function DesktopCheckout({setIsThankYouPage, product, order, setOrder}: any) {
  return (
    <>
      <Grid2 container columns={16}>
        <Grid2 size={8} sx={{backgroundColor: 'white'}}>
          <Box className="container" sx={{paddingTop: '20px'}}>
            <StoreForm setIsThankYouPage={setIsThankYouPage} product={product} order={order} setOrder={setOrder}/>
          </Box>
        </Grid2>
        <Grid2 size={8}>
          <Box className="summary-container">
            <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5' }}>
              <OrderSummary product={product}/>
            </AppBar>
          </Box>
        </Grid2>
      </Grid2>
    </>
  );
}

function ThankYouPage(orderId: any) {
  const konnectiveOrderUrl = `https://crm.konnektive.com/customer/cs/orders/?orderId=${orderId}`;
  return (
    <>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingBottom: '0'}}>
        <h1>Thank you for your purchase!</h1>
      </Box>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingTop: '0'}}>
          <p>We have received your order and will be processing it shortly</p>
      </Box>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingTop: '0'}}>
        <p>Order Number:</p>
        <a href={konnectiveOrderUrl}>orderId</a>
      </Box>
    </>

  );
}

function StoreForm({setIsThankYouPage, product, order, setOrder}: any) {
  const [isChecked, setIsChecked] = useState<boolean>(true);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      handleInputChange(event);
      setIsChecked(event.target.checked);
  };

  const handleInputChange = (e: any) => {
    const { id, value } = e.target;
    setOrder((prevState: any) => ({
      ...prevState,
      [id]: value
    }));
  };

  const handleFormSubmission = (e: any) => {
    e.preventDefault();
    const mappedOrder: Order = {
      firstName: order.firstName,
      lastName: order.lastName,
      emailAddress: order.emailAddress,
      address1: order.address1,
      address2: order.address2,
      city: order.city,
      state: order.state,
      country: order.country,
      postalCode: order.postalCode,
      phoneNumber: order.phoneNumber,
      cardNumber: order.cardNumber,
      cardSecurityCode: order.cardSecurityCode,
      cardMonth: order.expirationDate.split('/')[0],
      cardYear: order.expirationDate.split('/')[1],
      paySource: 'CREDITCARD',
      campaignId: `${product.campaignId}`,
      product1_id: `${product.productId}`,
      product1_qty: `${product.productQty}`
    };
    if(!isChecked){
      mappedOrder.altFirstName = order.altFirstName;
      mappedOrder.altLastName = order.altLastName;
      mappedOrder.altAddress1 = order.altAddress1;
      mappedOrder.altAddress2 = order.altAddress2;
      mappedOrder.altCity = order.altCity;
      mappedOrder.altState = order.altState;
      mappedOrder.altCountry = order.altCountry;
      mappedOrder.altPostalCode = order.altPostalCode;
    }
    try {
      postOrder(mappedOrder).then((d) => {
        console.log(d);
        setIsThankYouPage(true);
      });
    } catch (error) {}
  }


  return (
    <>
      <form id="checkout-form" onSubmit={handleFormSubmission}>
        <h3>Contact</h3>
        <div className="form-row">
          <FilledInput id="emailAddress" label="Email" placeholder="Enter your email" validate={isValidEmail} inputChange={handleInputChange}/>
        </div>

        <h3>Delivery</h3>

        <div className="form-row">
          <Dropdown id="country" label="Country" options={["US", "CA"]} inputChange={handleInputChange}/>
        </div>

        <div className="form-row">
          <FilledInput id="firstName" label="First Name" placeholder="Enter first name" validate={isValidName}inputChange={handleInputChange}/>
          <FilledInput id="lastName" label="Last Name" placeholder="Enter last name" validate={isValidName} inputChange={handleInputChange}/>
        </div>
        <div className="form-row">
          <FilledInput id="address1" label="Address" placeholder="Enter your address" validate={isValidAddress} inputChange={handleInputChange}/>
        </div>
        <div className="form-row">
          <FilledInput id="address2" label="Apartment, suite, etc. (optional)" placeholder="Apartment, suite, etc. (optional)" validate={isValidAddress} inputChange={handleInputChange}/>
        </div>
        <div className="form-row">
          <FilledInput id="city" label="City" placeholder="Enter your city" validate={isValidCity} inputChange={handleInputChange}/>
          <Dropdown id="state" label="State" options={["California", "Texas", "Ontario", "British Columbia"]} inputChange={handleInputChange}/>
          <FilledInput id="postalCode" label="Zip" placeholder="Enter zip code" validate={isValidZip} inputChange={handleInputChange}/>
        </div>
        <div className="form-row">
          <FilledInput id="phoneNumber" label="Phone" placeholder="Enter phone number" validate={isValidPhone} tooltip='In case we need to contact you about your order' inputChange={handleInputChange}/>
        </div>
        <h3>Payment</h3>
        <em>All transactions are secure and encrypted.</em>
        <div className="payment-container">
            <div className="form-row">
              <span>Credit card</span>
              <div>
                <img alt="VISA"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="MASTERCARD"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="AMEX"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
                <img alt="DISCOVER"
                    src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                    role="img" width="38" height="24"
                    className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
              </div>      
            </div>
            <div className="form-row">
              <FilledInput id="cardNumber" label="Card Number" placeholder="Enter card number" validate={isValidCreditCard} tooltip=' ' inputChange={handleInputChange}/>
            </div>
            <div className="form-row">
              <FilledInput id="expirationDate" label="Expiration date (MM / YY)" placeholder="MM/YY" validate={isValidExpirationDate} inputChange={handleInputChange}/>
              <FilledInput id="cardSecurityCode" label="Security code" placeholder="Security code" validate={isValidCVV} tooltip="3-digit security Code usually found on the back of your card. American Express cards have a 4-digit code located on the form." inputChange={handleInputChange}/>
            </div>
            <div className="form-row">
              <FilledInput id="" label="Name on Card" placeholder="Name on Card" validate={isValidName} inputChange={handleInputChange}/>
            </div>
            <div className="form-norow">
                <BillingCheckbox isChecked={isChecked} onChange={handleCheckboxChange}/>
            </div>
                {!isChecked && (
                  <>
                    <p>Billing Address</p>
                    <div className="form-row">
                        <Dropdown id="altCountry" label="Country" options={["United States", "Canada", "United Kingdom", "Australia"]} inputChange={handleInputChange}/>
                    </div>
                    <div className="form-row">
                      <FilledInput id="altFirstName" label="First Name" placeholder="Enter first name" validate={isValidName} inputChange={handleInputChange}/>
                      <FilledInput id="altLastName" label="Last Name" placeholder="Enter last name" validate={isValidName} inputChange={handleInputChange}/>
                    </div>
                    <div className="form-row">
                      <FilledInput id="altAddress1" label="Address" placeholder="Address" validate={isValidAddress} inputChange={handleInputChange}/>
                    </div>
                    <div className="form-row">
                      <FilledInput id="altAddress2" label="Apartment, suite, etc. (optional)" placeholder="Apartment, suite, etc. (optional)" validate={isValidCity} inputChange={handleInputChange}/>
                    </div>
                    <div className="form-row">
                      <FilledInput id="altCity" label="City" placeholder="Enter your city" validate={isValidCity} inputChange={handleInputChange}/>
                      <Dropdown id="altState" label="State" options={["California", "Texas", "Ontario", "British Columbia"]} inputChange={handleInputChange}/>
                      <FilledInput id="altPostalCode" label="Zip" placeholder="Enter zip code" validate={isValidZip} inputChange={handleInputChange}/>
                    </div>
                    <div className="form-row">
                        <FilledInput id="" label="Phone (Optional)" placeholder="Enter phone number" validate={isValidPhone} tooltip="In case we need to contact you about your order" inputChange={handleInputChange}/>
                    </div>
                  </>
                )}
        </div>

        <br />
        <em>Secure and encrypted</em>
        <button type="submit" className="pay-button">Pay Now</button>

        <em>Your info will be saved to a Shop account. By continuing, you agree to Shop’s Terms of Service and
            acknowledge the Privacy Policy.</em>
        <hr />
        <em>
            <div>
                <a href="#">Refund policy</a>
                <a href="#">Privacy policy</a>
                <a href="#">Terms of service</a>
            </div>
            <div>
                By placing this order, you agree to our Terms of Service and understand our Privacy Policy.
            </div>
        </em>
      </form>   
    </>
  )
}

function OrderSummary({product}: any) {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));
  return (
      product ? 
        (
          <>
            {isMobileOrTablet ? null : <div className="summary-header">Order Summary</div>}
            <div className="summary-item">
              <img src={product.productImagePath ?? vitamin} /><i>${product.msrp ?? ''}</i>
              <strong>{product.productName?.split('|')[0] ?? ''}</strong>
              <em>{product.productQty ?? ''} bottle{product.productQty > 1 ? 's' : ''}</em>
              <div className="clear"></div>
              </div>
              
              <div className="summary-item">
              <strong>Subtotal</strong>
              <i>${product.msrp ?? ''}</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item">
              <strong>Shipping</strong>
              <i>${product.shippingCost ?? '0.00'}</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item">
              <strong>Estimated taxes</strong>
              <i>$0.00</i>
              <div className="clear"></div>
              </div>
              <div className="summary-item summary-total">
              <strong>Total</strong>
              <i><span className="currency">USD</span>${product.msrp ?? '0.00'}</i>
              <div className="clear"></div>
            </div>
          </>
        ) : (
        <>
            <div className="summary-header">
            <Skeleton variant="text" width={150} height={30} />
            </div>
            <div className="summary-item">
            <Skeleton variant="rectangular" width={50} height={50} />
            <i><Skeleton variant="text" width={100} /></i>
            <strong><Skeleton variant="text" width={120} /></strong>
            <em><Skeleton variant="text" width={80} /></em>
            <div className="clear"></div>
            </div>
            
            <div className="summary-item">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item">
            <strong><Skeleton variant="text" width={120} /></strong>
            <i><Skeleton variant="text" width={50} /></i>
            <div className="clear"></div>
            </div>
            <div className="summary-item summary-total">
            <strong><Skeleton variant="text" width={80} /></strong>
            <i><Skeleton variant="text" width={100} /></i>
            <div className="clear"></div>
            </div>
        </>)
  )
}

export default App;
